import React, { useState, useEffect } from "react"
import { fetchCall } from "../../common/FetchHelpers";

import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";
import DateUtil from "../../common/dateUtil";
import StatusComp from "../../common/StatusComp";
const UserAccountListComp = (props) => {
    
    const accountUrl = "api/user-account/UserAccounts";
    
    const [showResult, setShowResult] = useState(false);
    const [items, setItems] = useState([]);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
   
    useEffect(() => {
        setLoading(true);


        fetchCall(accountUrl)
            .then((result)=>{
                //console.log(result);
                setItems(result);
                setLoading(false);
                setShowResult(true);

            },
            (err)=>{
                setLoading(false);
                //console.log(err);
                setShowError(true);

            }
        );
    }, []);


    const AccountStatus = (props)=>{
        let statusClass = "status";

        let statusLabel = props.children.deletedTimeStampUserTz? `Closed - ${props.children.deletedTimeStampUserTz}`:'Active';

        if (props.children.deletedTimeStampUserTz) {
            statusClass = `${statusClass} status-orange`;
        } else{
            statusClass = `${statusClass} status-green`;
        }
        return(
            <span className={statusClass} data-title="Status">{statusLabel}</span>
        )
    }


    return (
        <>

            {!showError && !loading && items.length > 0 &&

                <ul className="flex-table">
                    <li className="table-row table-header">
                        <div className="table-data">
                            <div className="table-cell">Account Number</div>
                            <div className="table-cell">Account Name</div>
                            <div className="table-cell">Financial Institution</div>
                            <div className="table-cell">Open Date</div>
                            <div className="table-cell">Status</div>
                        </div>
                        <div className="table-control flex-center">Edit | Close</div>
                    </li>

                    {items.map(item => {
                        return (
                            <li key={item.id} className="table-row">
                                <div className="table-data">
                                    <div className="table-cell" data-title="Account Number">{item.accountNumber}</div>
                                    <div className="table-cell" data-title="Account Name">{item.accountName}</div>
                                    <div className="table-cell" data-title="Financial Institution">{item.brokerDealerName}</div>
                                    <div className="table-cell" data-title="Open Date">{item.accountOpenDate}</div>
                                    <div className="table-cell" data-title="Status"><StatusComp status={item.status}>{item.statusLabel}</StatusComp></div>
                                    
                                </div>
                                <div className="table-control">
                                    {(item.status === "Rejected" || item.status === "Cancelled" || item.status === "Withdrawn"|| item.status === "Closed" ) ? <>
                                        <span className="btn-icon" onClick={p => props.onDetail(item)}><img className="icon-mid" src="img/icon/magnify.svg" alt="icon Detail" /></span>
                                        </>
                                        :
                                        (item.status === "Approved")?<>
                                        <span className="btn-icon" onClick={p => props.onDetail(item)}><img className="icon-mid" src="img/icon/magnify.svg" alt="icon Detail" /></span>
                                        <span className="btn-icon" onClick={p => props.onDelete(item)}><img className="icon-mid" src="img/icon/delete.svg" alt="icon Delete" /></span>
                                        </>:
                                        <>
                                        <span className="btn-icon" onClick={p => props.onEdit(item)}><img className="icon-mid" src="img/icon/edit.svg" alt="icon Edit" /></span>
                                        <span className="btn-icon" onClick={p => props.onDelete(item)}><img className="icon-mid" src="img/icon/delete.svg" alt="icon Delete" /></span>
                                        </>
                                    }
                                </div>
                            </li>
                        )
                    })
                    }
                </ul>
            }

            { items.length == 0 && <h4 className='flex-center pb-1em'>There are no accounts in your list. Click "Add Account" to create one.</h4>

            }


            {loading && <LoadingComp />}
            {showError && <ErrorComp />}
        </>
    );
};


export default UserAccountListComp;